// LoginPage.js
import React, { use, useState , useEffect} from "react";
import { useNavigate } from "react-router-dom";
import  "../index.css";
import logo from './data/logoa.png';
import Select from "react-select";
import { LogInIcon, Search } from "lucide-react";
import config from "./config";
import MHeader from "./header";
import Mfooter from "./footer";

import { Llogout } from "./config";

//const apiServerAddress = "https://api3e.soluzioni-it.eu/";
//const apiServerAddress = "http://localhost:3001/";
const customStyles = {
  control: (base) => ({
    ...base,
    width: "80%",  // Cambia larghezza
    minHeight: "40px", // Altezza minima
    fontSize: "16px",  // Dimensione testo
  }),
};
let bearer;
let loginSrv = ""
function LoginPage({ setUser, setPass,setBea }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [optionComuni, setOptionComuni] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  
  const [profilo, setProfilo] = useState("");
  const [urllogin, setUrllogin]= useState("");
  const [urlapi, setUrlapio]= useState("");
  //const [bearer,setBearer] = useState("");
  const navigate = useNavigate();
  
  
 
   useEffect(() => {
    /*setProfilo("");
    Llogout();*/
    
/*     fetch(config.apiUrl+"/getcomuni")
      .then((res) => res.json())
      .then((data) => setOptionComuni(data))
      .catch((error) => console.error("Errore nel fetch dei comuni:", error));
      if (optionComuni.length ===0)
         localStorage.setItem("comune",""); */

  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    try{
      const formData = new FormData();
      formData.append("username", username);
      formData.append("password", password);
   
      const response = await fetch(config.apiUrl+"/token", {
        method: "POST",
        body: formData,
      });
      if (!response.ok){

        console.log("errore autenticazione");
        throw new Error("Errore nella richiesta al server");
      }
      //else:
      
      //
      const data = await response.json();
      console.log("Token ricevuto:", data.access_token);  
      bearer = data.access_token;
      localStorage.setItem("token", data.access_token);
  /*    if (selectedOption)
        localStorage.setItem("comune", selectedOption.value);
    */  
      console.log(response.body);
      setUser(username);
      setPass(password);
      setBea(bearer);
      navigate("/landingpage");
      
    }  catch (err) {
        console.log(err);
        alert("Errore di autenticazione controllare username e password.")
        setUsername("")
        setPassword("")
        setSelectedOption("")
    }

    
    
  };

  return (
    <div className="App">
        <h2  className="App-header">{config.appName}</h2>
      <MHeader/>
      <form onSubmit={handleLogin}>
      <h1> Login Page</h1>
      
      Username:
      <input
        type="text"
        placeholder="Inserisci username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        />
      <p>
      </p>
      Password:
      <input
        type="password"
        placeholder="Inserisci password"
        value={password}
        onChange={(p) => setPassword(p.target.value)}
        /><p></p>

      {username  && password && (
        <button type="submit"><LogInIcon className="mr-2" /><br/>Login</button>
      )}
      <Mfooter/>
      </form>
    </div>
  );
}

export default LoginPage;